import { ComponentNameEnum } from '@/types';

const getGameSlotCombinationsEditorFieldConfig = () => ({
  componentName: ComponentNameEnum.GAME_SLOT_COMBINATIONS_EDITOR,
  options: {},
});

export default getGameSlotCombinationsEditorFieldConfig;
